import { render, staticRenderFns } from "./SPOP_LSPOP.vue?vue&type=template&id=4010430c&"
import script from "./SPOP_LSPOP.vue?vue&type=script&lang=js&"
export * from "./SPOP_LSPOP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports